import {createAction} from "redux-actions";

export const dismissMessage = createAction("signtasks/DISMISS_MESSAGE");
